import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	Container,
	Paper,
	Typography,
	Button,
	TextField,
} from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import {
	useDeleteAuthorMutation,
	useUpdateActorMutation,
} from '../../../store/apiSlice';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	backButton: {
		marginBottom: theme.spacing(2),
	},
}));

export function ActorDetails(props) {
	const classes = useStyles();
	const { id } = useParams();
	const location = useLocation();

	const actorName = location.state?.name;
	const navigate = useNavigate();
	const [deleteAuthor] = useDeleteAuthorMutation();
	const handleDelete = (e) => {
		deleteAuthor({ id });
		navigate('/admin/actors');
	};

	const [updateAuthor] = useUpdateActorMutation();
	const handleUpdate = (e) => {
		updateAuthor({ id, name: newAuthorName });
		navigate('/admin/actors');
	};

	const [newAuthorName, setNewAuthorName] = useState(actorName || '');

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Актьорски детайли</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Детайли
					</Typography>

					<Typography
						className={classes.title}
						component="h2"
						variant="h6"
						role="alert"
					>
						Име: {actorName || 'Няма намерен актьор.'}
					</Typography>

					<div className={classes.paper}>
						<Typography>Редактирай името на актьора:</Typography>
						<TextField
							value={newAuthorName}
							onChange={(e) => setNewAuthorName(e.target.value)}
							placeholder="Име на актьора"
						></TextField>
					</div>
					<Button startIcon={<EditIcon />} onClick={handleUpdate}>
						Запис
					</Button>
					<Button startIcon={<DeleteIcon />} onClick={handleDelete}>
						Изтрий
					</Button>
				</Paper>
			</Container>
		</div>
	);
}
